/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* jshint esversion: 11 */
import { fetch, post } from "../utils/http";
import { getIsWxClient, getQueryStringByName } from "../utils/lib";
import store from "@/store";
import { getPlayerInfo } from "./login";
/**
 * 获取微信Openid
 */
export const getWxOpenId = () => {
  return new Promise((resolve, reject) => {
    if (!getIsWxClient()) {
      reject("no wechat");
      return;
    }
    post("/system/app/weixin/getOpenId", { code: getQueryStringByName("code") || "" })
      .then((openId) => {
        store.dispatch("secne/set_user_info", {
          openId: openId,
        });
        resolve(openId);
      })
      .catch(() => {
        window.location.replace(
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx223be0d333565e9c&redirect_uri=" +
            encodeURIComponent(window.location.href) +
            "&response_type=code&scope=snsapi_base&state=1#wechat_redirect",
        );
      });
  });
};

/**
 * 微信支付-JsSdk 下单
 */
export const wxUnifiedOrder = (orderNo) => {
  return post("/system/app/product/unifiedOrder", { orderNo, openId: store.getters.openId });
};

/**
 * 联调支付 付款
 * "cooperatorOrder": "1539542996749463553 订单号",
 * "url": "https://www.yaoland.cn/ 支付后返回的页面",
 * "source": "1 来源（1-h5，2-pc）"
 */
export const yaojingPay = (cooperatorOrder, source, pid = "", wx = 1) => {
  return post("/system/app/product/cuPay", {
    cooperatorOrder: cooperatorOrder,
    url:
      process.env.VUE_APP_MAIN_BASE + "/PaySuccess?code=" + cooperatorOrder + "_" + pid + "_" + wx,
    source: source,
  }).then((res) => {
    getPlayerInfo();
    return res;
  });
};

/**
 * 联调支付 获取支付结果
 * "data": 1 支付结果(待支付0, 订购成功1, 订购失败2)
 */
export const yaojingPayResult = (cooperatorOrder) => {
  return post("/system/app/product/cuPayResult", {
    cooperatorOrder: cooperatorOrder,
  });
};

/**
 * 统一支付 下单接口
 * @param {*} orderNo
 */
export const yaojingPay_bak = (orderNo) => {
  return new Promise((resolve, reject) => {
    if (!getIsWxClient()) {
      reject("no wechat");
      return;
    } else {
      wxUnifiedOrder(orderNo).then((res) => {
        wx.chooseWXPay({
          appId: res.appId,
          timestamp: res.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: res.nonceStr, // 1支付签名随机串，不长于 32 位
          package: res.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: res.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign: res.paySign, // 支付签名
          success: function (successRes) {
            // 前端判断返回方式，微信团队郑重提示：不保证绝对可靠，切记！
            if (successRes.errMsg == "chooseWXPay:ok") {
              resolve({
                success: true,
                payStatus: 1, // 1成功， 2取消， 3失败 4异常
                msg: "支付成功",
              });
            } else if (successRes.errMsg == "chooseWXPay:cancel") {
              // 【支付取消】：用户取消支付不会进入这个判断，而是进入complate和cancel函数
              reject({
                success: false,
                payStatus: 2, // 1成功， 2取消， 3失败 4异常
                msg: "支付取消",
              });
            } else {
              reject({
                success: false,
                payStatus: 4, // 1成功， 2取消， 3失败 4异常
                msg: "支付异常",
              });
            }
          },
          fail: function () {
            reject({
              success: false,
              payStatus: 3, // 1成功， 2取消， 3失败 4异常
              msg: "支付失败",
            });
          },
          cancel: function () {
            reject({
              success: false,
              payStatus: 2, // 1成功， 2取消， 3失败 4异常
              msg: "支付取消",
            });
          },
        });
      });
    }
  });
};

/**
 * 获取微信公众号 JS-SDK签名
 */
export const getWxSign = (url) => {
  const _url = `${process.env.NODE_ENV == "prodtest" ? "pro/" : "/"}system/app/weixin/getSign`;
  return post(_url, { url });
};

// import { getWxSign } from "../api/pay/weChatMp";
//const authUrl = `${window.location.origin}${to.fullPath}`;
const weChatFun = (params, device) => {
  const shareConfig = {
    title: params.title || "曜境元宇宙一起数字藏品首发",
    desc: params.desc || "各大品牌的元宇宙虚拟空间等你来探索",
    link: params.allowShare ? params.authUrl : window.location.origin,
    imgUrl:
      params.img ||
      process.env.VUE_APP_OSS_URL + "system/2022/06/19/yaojinglogo_20220619231418A011.png",
  };

  let jsApiList = [
    "onMenuShareAppMessage",
    "onMenuShareTimeline",
    "updateTimelineShareData",
    "updateAppMessageShareData",
  ];
  if (params.wXPay) {
    jsApiList.push("chooseWXPay");
  }
  const url = decodeURIComponent(device == "ios" ? window.entryUrl : params.authUrl);
  getWxSign(url).then((res) => {
    const result = JSON.parse(res);
    wx.config({
      debug: false,
      appId: result.appId,
      timestamp: result.timestamp,
      nonceStr: result.nonceStr,
      signature: result.signature,
      jsApiList: jsApiList,
    });
    wx.ready(() => {
      wx.onMenuShareAppMessage(shareConfig);
      wx.onMenuShareTimeline(shareConfig);
      wx.updateTimelineShareData(shareConfig);
      wx.updateAppMessageShareData(shareConfig);
    });
  });
};

/**
 *
 * @param { fullPath, title, desc, img, wXPay }
 * @returns
 */
export const weChatJsConfig = (params) => {
  console.log("🚀 -> weChatJsConfig -> params", params);
  if (process.env.NODE_ENV != "production") return;
  if (!getIsWxClient()) return;
  let authUrl = `${window.location.origin}${params.fullPath}`;

  if (device.ios()) {
    // IOS
    if (window.entryUrl == "" || window.entryUrl == undefined) {
      window.entryUrl = authUrl; // 将后面的参数去除
    }
    weChatFun(
      {
        authUrl,
        title: params.title,
        desc: params.desc,
        img: params.img,
        wXPay: params.wXPay,
        allowShare: params.allowShare,
      },
      "ios",
    );
  } else {
    // 安卓
    setTimeout(function () {
      weChatFun(
        {
          authUrl,
          title: params.title,
          desc: params.desc,
          img: params.img,
          wXPay: params.wXPay,
          allowShare: params.allowShare,
        },
        "android",
      );
    }, 500);
  }
};
